export enum SearchOrderTypeEnum {
    OrderId = 'orderId',
    ColonyOrderId = 'colonyOrderId',
    SeqOrderId = 'seqOrderId',
    WellplateId = 'wellplateId',
    WellplateName = 'wellplateName',
    OrderOrWellplateName = 'orderOrWellplateName',
    ALL = 'all',
}
